const languageInfo = {
    path: '',
    name: '🇮🇪 En',
    shorthand: 'en',
}

exports.en = languageInfo
